import { aggregationTypes } from '../../constants/event';
import { formatJSON } from '../../utils/common';

const manualInitialState = {
  code: null,
  aggregationType: aggregationTypes.COUNT,
};

const manual = (state = manualInitialState, action) => {
  switch (action.type) {
    case 'CHANGE_EVENT_MANUAL_CODE':
      return {
        ...state,
        code: formatJSON(action.code),
      };

    case 'UPDATE_LOCATION':
      return manualInitialState;

    default:
      return state;
  }
};

export default manual;

export const getCode = (state) => state.code;
